import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// Iter 161 (Kamel) — Badge + pop-up « ✅ J'ai déjà payé » :
// signalements envoyés par les voyageurs depuis les emails de relance.
// Méssa vérifie la saisie des règlements puis marque l'alerte traitée.
export const DejaPayeAlerts = ({ API, username, password }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const fetchAlertes = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/admin/paiement-alertes`, { auth: { username, password } });
      setData(r.data);
    } catch { /* non bloquant */ }
  }, [API, username, password]);

  useEffect(() => {
    fetchAlertes();
    const iv = setInterval(fetchAlertes, 120000);
    return () => clearInterval(iv);
  }, [fetchAlertes]);

  const traiter = async (id) => {
    try {
      await axios.post(`${API}/admin/paiement-alertes/${id}/traiter`, {}, { auth: { username, password } });
      fetchAlertes();
    } catch (e) {
      alert('Erreur : ' + (e.response?.data?.detail || e.message));
    }
  };

  if (!data || data.count === 0) return null;
  const alertes = (data.alertes || []).filter((a) => !a.traite);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="text-xs font-bold px-2.5 py-1 rounded-full border bg-green-50 text-green-700 border-green-300 hover:bg-green-100 animate-pulse"
        title="Des voyageurs signalent avoir déjà payé — vérifier la saisie des règlements"
        data-testid="deja-paye-badge"
      >
        💶 {data.count} « déjà payé »
      </button>
      {open && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4" data-testid="deja-paye-popup">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden border-4 border-green-600">
            <div className="bg-green-600 text-white px-5 py-4 flex items-center justify-between">
              <div>
                <div className="font-bold text-lg">💶 Signalements « j'ai déjà payé »</div>
                <div className="text-sm opacity-90">Ces voyageurs affirment avoir tout réglé — vérifiez la saisie des règlements sur leur fiche.</div>
              </div>
              <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white text-2xl font-bold px-2" data-testid="deja-paye-close">✕</button>
            </div>
            <div className="p-4 overflow-y-auto">
              {alertes.map((a) => (
                <div key={a.id} className="flex items-start justify-between gap-3 border-b py-3" data-testid={`deja-paye-alerte-${a.id}`}>
                  <div className="text-sm">
                    <div className="font-bold text-gray-800">{a.nom || a.email}</div>
                    <div className="text-gray-500 text-xs">{a.destination} — {a.email}</div>
                    <div className="text-xs mt-1">
                      Au moment du signalement : total <strong>{Number(a.total).toFixed(2)} €</strong>, payé <strong className="text-green-600">{Number(a.paye).toFixed(2)} €</strong>, reste <strong className="text-red-600">{Number(a.reste).toFixed(2)} €</strong>
                    </div>
                    <div className="text-[11px] text-gray-400 mt-0.5">Signalé le {new Date(a.signale_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}</div>
                  </div>
                  <button
                    onClick={() => traiter(a.id)}
                    className="shrink-0 text-xs font-bold px-3 py-1.5 rounded-lg bg-green-600 text-white hover:bg-green-700"
                    data-testid={`deja-paye-traiter-${a.id}`}
                  >
                    ✅ Vérifié / traité
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DejaPayeAlerts;
